/**
 * Where a service-desk ticket stands (PAUL-3646). Integers on the wire. Done and Declined are the
 * closing statuses; in the normal flow only the approve endpoint produces them.
 */
export enum ServiceDeskTicketStatus {
  Logged = 0,
  Investigating = 1,
  InProgress = 2,
  Done = 3,
  Declined = 4,
}

export const ServiceDeskTicketStatusTranslations: Record<ServiceDeskTicketStatus, string> = {
  [ServiceDeskTicketStatus.Logged]: 'service_desk.status.logged',
  [ServiceDeskTicketStatus.Investigating]: 'service_desk.status.investigating',
  [ServiceDeskTicketStatus.InProgress]: 'service_desk.status.in_progress',
  [ServiceDeskTicketStatus.Done]: 'service_desk.status.done',
  [ServiceDeskTicketStatus.Declined]: 'service_desk.status.declined',
};

/** `lib-select` options ({ key, value }), in workflow order. */
export const ServiceDeskTicketStatusOptions = [
  ServiceDeskTicketStatus.Logged,
  ServiceDeskTicketStatus.Investigating,
  ServiceDeskTicketStatus.InProgress,
  ServiceDeskTicketStatus.Done,
  ServiceDeskTicketStatus.Declined,
].map((status) => ({ key: ServiceDeskTicketStatusTranslations[status], value: status }));

export function isServiceDeskTicketClosed(status: ServiceDeskTicketStatus | null | undefined): boolean {
  return status === ServiceDeskTicketStatus.Done || status === ServiceDeskTicketStatus.Declined;
}
